import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import WorkflowCompatibility from "../../../components/Workflow/WorkflowCompatibility";

class NL_Translate_translate extends PureComponent {
  render() {
    return (
      <div className="row" id="nl_translate_translate">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>NL.Translate.translate</h2>
              <p>
                NL.Translate.translate translates sections inside a string.
              </p>
              <p style={{ color: "#D32F2F", fontWeight: "bold" }}>You require a seperate AWS account with appropriate permissions.</p>
              <WorkflowCompatibility front={false} back={true} />
              <h3>Options</h3>
              <table>
                <tbody>
                  <tr>
                    <td className="b top">Option</td>
                    <td className="b top">Description</td>
                  </tr>
                  <tr>
                    <td className="b">langInput</td>
                    <td>
                      Lang Input is the input language.
                      <br />
                      <i>"en", "fr", "de", "es" default is "en"</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">langOuput</td>
                    <td>
                      Lang Output sets the languages to translate to
                      <br />
                      <i>["de", "es", "fr"] default is ["fr"]</i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>NL.Translate.translate Example</h2>
              <p>This example translates some the text "Hello World" into french spanish but not german.</p>
              <div className="darkCode">
                <div>
                  <span className="jsonP">var</span>{" "}
                  <span className="nodeCode">init_options</span>{" "}
                  <span className="jsonP">=</span>{" "}
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i1">
                  <span className="nodeCode">accessKeyId</span>
                  <span className="jsonA">: "</span>
                  <span className="jsonG">AKLMEDKENISJQOUT...</span>
                  <span className="jsonA">",</span>
                </div>
                <div className="i1">
                  <span className="nodeCode">secretAccessKey</span>
                  <span className="jsonA">: "</span>
                  <span className="jsonG">ofmsSgfmnuienSBNemiwo+fknwnofg+sdFSMF...</span>
                  <span className="jsonA">",</span>
                </div>
                <div className="i1">
                  <span className="nodeCode">S3Bucket</span>
                  <span className="jsonA">: "</span>
                  <span className="jsonG">my_bucket</span>
                  <span className="jsonA">",</span>
                </div>
                <div className="i1">
                  <span className="nodeCode">S3TranslateCacheKey</span>
                  <span className="jsonA">: "</span>
                  <span className="jsonG">my_project/cache.json</span>
                  <span className="jsonA">",</span>
                </div>
                <div className="i1">
                  <span className="nodeCode">langInput</span>
                  <span className="jsonA">: "</span>
                  <span className="jsonG">en</span>
                  <span className="jsonA">",</span>
                </div>
                <div className="i1">
                  <span className="nodeCode">langOuput</span>
                  <span className="jsonA">: [</span>
                  <span className="jsonA">"</span>
                  <span className="jsonG">fr</span>
                  <span className="jsonA">", </span>
                  <span className="jsonA">"</span>
                  <span className="jsonG">es</span>
                  <span className="jsonA">", </span>
                  <span className="jsonA">"</span>
                  <span className="jsonG">de</span>
                  <span className="jsonA">"</span>
                  <span className="jsonA">]</span>
                </div>
                <div>
                  <span className="jsonY">&#125;</span>
                  <span className="jsonA">;</span>
                </div>
                <div>
                  <br />
                </div>
                <div>
                  <span className="jsonP">var</span>{" "}
                  <span className="nodeCode">text</span>{" "}
                  <span className="jsonP">=</span>{" "}
                  <span className="jsonA"> "</span>
                  <span className="jsonG">--TS--Hello World--TE--</span>
                  <span className="jsonA">";</span>
                </div>
                <div>
                  <br />
                </div>
                <div>
                  <span className="jsonP">var</span>{" "}
                  <span className="nodeCode">options</span>{" "}
                  <span className="jsonP">=</span>{" "}
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i1">
                  <span className="nodeCode">langInput</span>
                  <span className="jsonA">: "</span>
                  <span className="jsonG">en</span>
                  <span className="jsonA">",</span>
                </div>
                <div className="i1">
                  <span className="nodeCode">langOutput</span>
                  <span className="jsonA">: [</span>
                  <span className="jsonA">"</span>
                  <span className="jsonG">fr</span>
                  <span className="jsonA">", </span>
                  <span className="jsonA">"</span>
                  <span className="jsonG">es</span>
                  <span className="jsonA">"</span>
                  <span className="jsonA">]</span>
                </div>
                <div>
                  <span className="jsonY">&#125;</span>
                  <span className="jsonA">;</span>
                </div>
                <div>
                  <br />
                </div>
                <div>
                  <span className="jsonPink">NL</span>
                  <span className="jsonA">.</span>
                  <span className="nodeCode">Translate</span>
                  <span className="jsonA">.</span>
                  <span className="jsDeclaration">init</span>
                  <span className="jsonY">(</span>
                  <span className="nodeCode">init_options</span>
                  <span className="jsonA">, </span>
                  <span className="jsonP">function</span>
                  <span className="jsonA">(</span>
                  <span className="jsonPink">err</span>
                  <span className="jsonA">, </span>
                  <span className="jsonPink">data</span>
                  <span className="jsonA">) </span>
                  <span className="jsonA">&#123;</span>
                </div>
                <div className="i1">
                  <span className="jsonA">if (</span>
                  <span className="jsonPink">err</span>
                  <span className="jsonA">) </span>
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i2">
                  <span className="jsComment">// Failed to init</span>
                </div>
                <div className="i1">
                  <span className="jsonY">&#125;</span>
                  <span className="jsonA"> else </span>
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i2">
                  <span className="jsonPink">NL</span>
                  <span className="jsonA">.</span>
                  <span className="nodeCode">Translate</span>
                  <span className="jsonA">.</span>
                  <span className="jsDeclaration">translate</span>
                  <span className="jsonY">(</span>
                  <span className="nodeCode">text</span>
                  <span className="jsonA">, </span>
                  <span className="nodeCode">options</span>
                  <span className="jsonA">, </span>
                  <span className="jsonP">function</span>
                  <span className="jsonA">(</span>
                  <span className="jsonPink">err</span>
                  <span className="jsonA">, </span>
                  <span className="jsonPink">data</span>
                  <span className="jsonA">) </span>
                  <span className="jsonA">&#123;</span>
                </div>
                <div className="i3">
                  <span className="jsonA">if (</span>
                  <span className="jsonPink">err</span>
                  <span className="jsonA">) </span>
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i4">
                  <span className="jsComment">// Failed</span>
                </div>
                <div className="i3">
                  <span className="jsonY">&#125;</span>
                  <span className="jsonA"> else </span>
                  <span className="jsonY">&#123;</span>
                </div>
                <div className="i4">
                  <span className="jsComment">/*</span>
                </div>
                <div className="i5">
                  <span className="jsComment">Example output</span>
                </div>
                <div className="i5">
                  <span className="jsComment">&#123;</span>
                </div>
                <div className="i6">
                  <span className="jsComment">es: 'Halo mundo',</span>
                </div>
                <div className="i6">
                  <span className="jsComment">fr: 'Bonjour le monde'</span>
                </div>
                <div className="i5">
                  <span className="jsComment">&#125;</span>
                </div>
                <div className="i4">
                  <span className="jsComment">*/</span>
                </div>
                <div className="i3">
                  <span className="jsonY">&#125;</span>
                </div>
                <div className="i2">
                  <span className="jsonA">&#125;</span>
                  <span className="jsonY">)</span>
                  <span className="jsonA">;</span>
                </div>
                <div className="i1">
                  <span className="jsonY">&#125;</span>
                </div>
                <div>
                  <span className="jsonA">&#125;</span>
                  <span className="jsonY">)</span>
                  <span className="jsonA">;</span>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default NL_Translate_translate;



// WEBPACK FOOTER //
// ./src/components/knowlege/workflow/NL_Translate_translate.js